<template>
  <div>
    <div class="headerDiv"></div>
    <van-nav-bar
      :title="title + ' ' + vType"
      :left-text="leftText"
      :left-arrow="showleftIcon"
      @click-left="onClickLeft"
      fixed
    >
      <van-icon name="ellipsis" slot="right" @click="onClickRight" />
    </van-nav-bar>
    <van-popup v-model="showMenu" position="right">
      <ul>
        <li>
          <van-icon name="manager-o" />
          &nbsp;
          {{ username }}
        </li>
        <li v-if="isShowHome && !isFromDriver" @click="gotoHome">
          <van-icon name="wap-home" />&nbsp;&nbsp;&nbsp;主页
        </li>
        <li @click="doReload">
          <van-icon name="replay" />&nbsp;&nbsp;&nbsp;刷新
        </li>
        <li @click="loginOut" v-if="!isFromDriver">
          <van-icon name="close" />&nbsp;&nbsp;&nbsp;退出登录
        </li>
        <li @click="changPwd" v-if="!isFromDriver">
          <van-icon name="edit" />&nbsp;&nbsp;&nbsp;修改密码
        </li>
        <li @click="updateApp" v-if="!isFromDriver">
          <van-icon name="upgrade" />&nbsp;&nbsp;&nbsp;检查更新
        </li>
        <li @click="gotoRedis">
          <van-icon name="brush-o" />&nbsp;&nbsp;&nbsp;缓存管理
        </li>
        <li><van-icon name="info-o" />&nbsp;&nbsp;&nbsp;v {{ ver }}</li>
        <!-- 当前是测试版本 或 正式悦到账号 显示 -->
        <li @click="tabUrl" v-if="showTabUrl && !isFromDriver">
          <van-icon name="exchange" />&nbsp;&nbsp;&nbsp;切换版本
        </li>
        <li @click="loadScript" v-if="showTabUrl && !isFromDriver">
          <van-icon name="tv-o" />&nbsp;&nbsp;&nbsp;开启调试
        </li>
        <!-- 当前是测试版本 或 正式悦到账号 显示 -->
        <!-- <li @click="showKefuLogin = true" v-if="showTabUrl">
          <van-icon name="exchange" />&nbsp;&nbsp;&nbsp;客服登录
        </li>-->
      </ul>
    </van-popup>

    <!-- 版本选择 -->
    <van-popup v-model="isShowUrl" position="bottom">
      <van-picker
        :columns="editionOption"
        show-toolbar
        @cancel="onChangeUrlCancel"
        @confirm="onChangeUrlConfirm"
      />
    </van-popup>

    <!-- 公司选择 -->
    <van-popup v-model="showCompCheck" position="bottom">
      <van-picker
        :columns="compList"
        show-toolbar
        @cancel="showCompCheck = false"
        @confirm="onCheckComp"
      />
    </van-popup>

    <!-- 客服登录 -->
    <van-popup
      v-model="showKefuLogin"
      style="width: 80%; text-align: -webkit-auto"
    >
      <!-- <van-dialog
      v-model="showKefuLogin"
      show-cancel-button
      v-on:confirm="kefuLogin"
      v-on:cancel="showKefuLogin=false;kefuPwd=null"
      style="text-align: -webkit-auto;"
      >-->
      <div style="margin-top: 10px">
        <van-cell
          title="企业名称"
          is-link
          arrow-direction="down"
          :value="CompName"
          @click="showCompCheck = true"
        />
        <van-field
          label="客服密码"
          v-model="kefuPwd"
          type="password"
          required
          ref="textpwd"
          input-align="right"
        />
      </div>
      <div style="margin-top: 10px; margin-bottom: 10px">
        <van-row type="flex" justify="space-around">
          <van-col span="9">
            <van-button
              type="default"
              block
              @click="
                showKefuLogin = false;
                kefuPwd = null;
              "
              >取消</van-button
            >
          </van-col>
          <van-col span="9">
            <van-button type="primary" block @click="kefuLogin"
              >登录</van-button
            >
          </van-col>
        </van-row>
      </div>
      <!-- </van-dialog> -->
    </van-popup>

    <van-dialog
      id="changPwdWin"
      v-model="isShowChangePwd"
      title="修改密码"
      show-confirm-button
      :before-close="showChangPwd"
      show-cancel-button
    >
      <!-- 用户代码 -->
      <van-field
        v-model="sysUser.UserCode"
        label="用户代码"
        readonly
        disabled
        label-align="left"
      />
      <!-- 用户名称 -->
      <van-field
        v-model="sysUser.UserName"
        label="用户名称"
        readonly
        disabled
        label-align="left"
      />
      <!-- 原密码 -->
      <van-field
        v-model="oldpwd"
        type="password"
        label="原密码 "
        label-align="left"
        placeholder="请输入原密码"
      />
      <van-field
        v-model="newpwd1"
        label="新密码 "
        label-align="left"
        placeholder="请输入新密码"
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            @click="generateRandomPassword"
            >生成并复制密码</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="newpwd2"
        label="确认密码"
        label-align="left"
        placeholder="再次输入新密码"
      />
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    showBack: Boolean,
    showName: Boolean,
    isFromDriver: Boolean,
  },
  data() {
    return {
      ver: window.ver,
      showMenu: false,
      leftText: "",
      showleftIcon: false,
      username: window.localStorage.getItem("adminInfo")
        ? JSON.parse(window.localStorage.getItem("adminInfo")).UserName
        : "***",
      showTabUrl: false,
      isShowUrl: false,
      edition: location.hostname, //版本
      editionOption: [
        {
          text: "正式环境",
          url: "https://hd.class.busboss.cn?v=" + new Date().getTime(),
        },
        {
          text: "测试环境",
          url: "https://test.hd.class.busboss.cn?v=" + new Date().getTime(),
        },
        {
          text: "开发环境",
          url: "http://192.168.137.1:8080?v=" + new Date().getTime(),
        },
      ],
      vType: "",
      showKefuLogin: false,
      kefuPwd: null,
      CompName: null,
      CompInfo: null,
      showCompCheck: false,
      compList: [],
      isShowChangePwd: false,
      sysUser: {
        GID: null,
        UserCode: "",
        UserName: "",
        CompGID: null,
      },
      oldpwd: null,
      newpwd1: null,
      newpwd2: null,
      isShowCyw: true,
    };
  },
  computed: {
    isShowHome() {
      return window.location.hash != "#/";
    },
  },
  watch: {
    showKefuLogin() {
      if (this.showKefuLogin && this.compList.length <= 0) {
        //this.$refs.textpwd.focus();
        let params = {
          CompTypeCode: "Operate",
          sort: "CompFullName",
          dir: "ASC",
        };
        this.$http
          .post(this.$api.getCompInfo, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              res.data.forEach((comp) => {
                this.compList.push({
                  text: comp.CompFullName + "(" + comp.CompNickName + ")",
                  GID: comp.GID,
                  CompName: comp.CompFullName,
                });
              });
            }
          });
      }
    },
  },
  methods: {
    //生成随机密码并复制
    generateRandomPassword() {
      this.newpwd1 = this.$utils.randomPassword(10);
      this.$copyText(this.newpwd1).then(
        (e) => {
          alert("密码生成成功：" + this.newpwd1 + "已复制到剪贴板");
          // console.log("复制成功：", e);
        },
        (e) => {
          alert("密码生成成功，但是复制失败，请手动复制。");
          //console.log("复制失败：", e);
        }
      );
    },
    //开启调试
    loadScript() {
      this.$utils.loadScript(
        // "https://cdn.jsdelivr.net/npm/vconsole@3.3.4/dist/vconsole.min.js",
        "https://class.busboss.cn/Scripts/vconsole.min.js",
        function() {
          /* eslint-disable */
          var vConsole = new VConsole();
        }
      );
    },
    //修改密码
    showChangPwd(action, done) {
      if (action !== "confirm") {
        done();
        return;
      }
      if (!this.oldpwd) {
        this.$dialog.alert({
          message: "请输入原密码",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      if (!this.newpwd1 || this.newpwd1 !== this.newpwd2) {
        this.$dialog.alert({
          message: "两次密码输入不匹配，请重新输入",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      if (this.oldpwd === this.newpwd1) {
        this.$dialog.alert({
          message: "您输入的新密码和原密码一致，请重新设置一个密码！",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      let cPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[_~`!@#$%^&*()\-+={}\[\]\|\\:;"'<>,\.\?\/])[\w~`!@#$%^&*()\-+={}\[\]\|\\:;"'<>,\.\?\/]{10,20}$/;
      if (!cPattern.test(this.newpwd1)) {
        this.$dialog.alert({
          message:
            "请输入由10位到20位、由数字、大写、小写字母和特殊字符四种符号组成的密码！",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      // const sm2 = require("sm-crypto").sm2;
      var oldpwdEnc = "";
      var newpwdEnc = "";
      try {
        oldpwdEnc = sm2.doEncrypt(this.oldpwd, window._UserSm2PublicKey, 1);
        newpwdEnc = sm2.doEncrypt(this.newpwd1, window._UserSm2PublicKey, 1);
      } catch (error) {
        //不支持sm2 直接传明文
        oldpwdEnc = this.oldpwdEnc;
        newpwdEnc = this.newpwd1;
      }
      this.loading = true;
      let params = {
        _CompGID: this.sysUser.CompGID,
        _OperGID: this.sysUser.GID,
        UserGID: this.sysUser.GID,
        OldPwd: oldpwdEnc,
        NewPwd: newpwdEnc,
      };
      this.$http
        .post(this.$api.onChangePwd, this.$qs.stringify(params))
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.$toast("修改密码成功");
            done();
            //修改成功，记录新密码至缓存
            window.localStorage.setItem("userpwd", this.newpwd1);
            //修改成功 返回登录页
            this.loginOut(true);
          } else {
            this.$dialog.alert({
              message: res.msg,
              getContainer: "#changPwdWin",
            });
            done(false);
          }
        });
    },
    changPwd() {
      this.sysUser = JSON.parse(window.localStorage.getItem("adminInfo"));
      this.isShowChangePwd = true;
    },
    onCheckComp(value) {
      this.CompName = value.text;
      this.CompInfo = value;
      this.showCompCheck = false;
    },
    //客服登录
    kefuLogin() {
      if (!this.CompName) {
        this.$toast("请选择公司");
        return;
      }
      if (!this.kefuPwd) {
        this.$toast("请输入客服密码");
        return;
      }
      let params = {
        CompName: this.CompName,
        CompGID: this.CompInfo.GID,
        KeFuCode: this.kefuPwd,
        model: {
          UserCode: window.localStorage.getItem("username"),
          UserPwd: window.localStorage.getItem("userpwd"),
        },
      };
      this.$http
        .post(this.$api.onKefuLogin, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            //客服登录成功
          }
        });
    },
    onChangeUrlConfirm(value) {
      if (window.framework) {
        if (window.framework.jsLoadUrl) {
          window.framework.jsLoadUrl(value.url);
        }
      } else {
        //网页端 直接跳转
        window.location.href = value.url;
      }
    },
    onChangeUrlCancel() {
      this.isShowUrl = false;
    },
    //切换版本
    tabUrl() {
      //if (window.framework) {
      this.isShowUrl = true;
      // } else {
      //   this.$toast("请在手持机应用内切换");
      // }
    },
    //检测更新
    updateApp() {
      if (window.framework) {
        if (window.framework.jsAppCheckUpdate) {
          window.framework.jsAppCheckUpdate();
        }
      } else {
        this.$toast("请在手持机应用内更新");
      }
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    onClickRight() {
      this.showMenu = !this.showMenu;
    },
    gotoHome() {
      this.$router.push("/");
    },
    gotoRedis() {
      this.$router.push({
        name: "RedisCacheManagement",
      });
    },
    doReload() {
      let that = this;
      this.$toast.loading({
        mask: false,
        forbidClick: true,
        message: "加载中...",
        duration: 0,
      });
      //重新获取权限
      this.$http
        .post(this.$api.getUserInfo, this.$qs.stringify({}))
        .then((res) => {
          if (res.success) {
            window.localStorage.setItem(
              "adminInfo",
              JSON.stringify(res.data.SysUser)
            );
            window.localStorage.setItem(
              "adminParams",
              JSON.stringify(res.data.SysParams)
            );
            window.localStorage.setItem(
              "adminRights",
              JSON.stringify(res.data.SysRights)
            );
            if (window._exceptionlessClient) {
              window._exceptionlessClient.config.setUserIdentity(
                res.data.SysUser.UserCode,
                res.data.SysUser.UserName
              );
              window._exceptionlessClient.config.useSessions();
            }
            window.location.reload();
          }
        });
      //this.$router.go(0);
    },
    loginOut(isClear) {
      let user_name = window.localStorage.getItem("username");
      let user_pwd = window.localStorage.getItem("userpwd");
      let isRpwd = this.$utils.getSysParams("IsRememberPwd");
      let query = {};
      //console.log(window.localStorage.getItem("isShowCyw"))
      //return
      if (window.localStorage.getItem("isShowCyw") == "false") {
        //alert(1)
        this.isShowCyw = false;
        query.isShowCyw = "false";
      }
      window.localStorage.clear();
      if (isRpwd !== "0" || !isClear) {
        //alert(user_pwd)
        // 1.记住密码--登录成功后将密码保存到localStorage中
        window.localStorage.setItem("username", user_name);
        window.localStorage.setItem("userpwd", user_pwd);
      }

      //跳转到登录
      this.$router.push({
        path: "/redirect",
        query: query,
      });
    },
  },
  created() {
    this.showleftIcon = this.showBack;
    if (this.showBack) {
      this.leftText = "返回";
    }
    var c = window.localStorage.getItem("adminInfo");
    c = c ? JSON.parse(c) : null;
    c = c && c.CompGID ? c.CompGID.toUpperCase() : null;
    if (
      c == "7EEC93FA-C72C-44EA-8F49-9F57CD7D3451" ||
      this.edition == "test.hd.class.busboss.cn" ||
      this.edition == "192.168.137.1" ||
      this.edition == "localhost"
    ) {
      this.showTabUrl = true;
    }
    if (this.edition == "test.hd.class.busboss.cn") {
      this.vType = "(测试)";
    } else if (this.edition == "192.168.137.1") {
      this.vType = "(本地)";
    } else {
      this.vType = "";
    }
    // console.log(this.$router);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.headerDiv {
  height: 45px;
}

.header {
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 18px;
  background-color: #f7a33c;
  color: #fff;
}

.van-popup.van-popup--right {
  height: 100%;
  top: 50%;
  right: 0;
  width: 50%;
  background-color: #f1f1f1;
}

.van-nav-bar,
.van-nav-bar__title {
  color: #fff;
  background-color: #f7a33c;
}

.van-nav-bar__text,
.van-nav-bar .van-icon {
  color: #fff;
  // font-size: 0.33rem;
}

.van-nav-bar .van-icon.van-icon-ellipsis {
  font-size: 25px;
}

ul li {
  text-align: left;
  padding-left: 10px;
  line-height: 50px;
  font-size: 16px;
  border-bottom: 2px solid #555562;
}

.van-nav-bar__text:active {
  background-color: transparent;
}
</style>
